import { FeatureFlagKeys } from './featureFlagKeys';
import { useEvaluatedFeatureFlagsQuery } from './useEvaluatedFeatureFlagsQuery';

export interface FeatureFlagState {
    value: boolean;
    isLoading: boolean;
}

export function useFeatureFlagWithStatus(key: FeatureFlagKeys, defaultValue: boolean): FeatureFlagState {
    const { data, isLoading } = useEvaluatedFeatureFlagsQuery();

    if (data === undefined) {
        return { value: defaultValue, isLoading };
    }

    const value = data[key];
    return { value: typeof value === 'boolean' ? value : defaultValue, isLoading };
}
